import { Breadcrumb, Col, Row } from 'antd';
import { URL_HOME } from 'routes/RouterConfig';
import { useTableContext } from 'hooks/MenuTableAuthContext';

export const NavLayout = () => {
  const { openMenuInfo } = useTableContext();
  const mappedItems = openMenuInfo.depth?.map((item) => {
    const newItem = { title: item };
    return newItem;
  }) || [];

  mappedItems.unshift({ title: (
    <a href={URL_HOME}>홈</a>
    )});

  return (<>
      { openMenuInfo?.depth?.length &&
        <Row>
          <Col span={24} className='layout-nav'>
          <Breadcrumb
            items={mappedItems} />
          </Col>
        </Row>
      }
    </>
  )
}